"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusModalTypes = exports.FormModalTypes = exports.ModalType = void 0;
var ModalType;
(function (ModalType) {
    ModalType["EDIT"] = "edit";
    ModalType["VIEW"] = "view";
    ModalType["ADD"] = "add";
})(ModalType = exports.ModalType || (exports.ModalType = {}));
var FormModalTypes;
(function (FormModalTypes) {
    FormModalTypes["EDIT_FORM"] = "EDIT_FORM";
    FormModalTypes["VIEW_FORM"] = "VIEW_FORM";
})(FormModalTypes = exports.FormModalTypes || (exports.FormModalTypes = {}));
var StatusModalTypes;
(function (StatusModalTypes) {
    StatusModalTypes["SUCCESS"] = "SUCCESS";
    StatusModalTypes["FAIL"] = "FAIL";
    StatusModalTypes["WARNING"] = "WARNING";
})(StatusModalTypes = exports.StatusModalTypes || (exports.StatusModalTypes = {}));
